import { Wind, Flame, Music, MessageCircleHeart, Sparkles, ArrowUpRight, CircleDot, Waves, Leaf } from "lucide-react";
import { Reveal, Eyebrow, scrollToId } from "./Reveal";
import { useLang } from "@/i18n/LangContext";

const META = [
  { id: "dynamic", icon: Wind, span: "md:col-span-2" },
  { id: "kundalini", icon: Flame, span: "" },
  { id: "chakra", icon: CircleDot, span: "" },
  { id: "sound", icon: Waves, span: "" },
  { id: "breathwork", icon: Leaf, span: "" },
  { id: "whiterobe", icon: Music, span: "" },
  { id: "nomind", icon: MessageCircleHeart, span: "" },
  { id: "guidance", icon: Sparkles, span: "" },
];

export default function Offerings() {
  const { t } = useLang();
  const cards = t("offerings.cards");
  return (
    <section id="meditations" data-testid="meditations-offerings-section" className="px-5 py-24 sm:px-8 lg:py-32" style={{ backgroundColor: "var(--bg-surface)" }}>
      <div className="mx-auto max-w-7xl">
        <Reveal className="mb-14 flex flex-wrap items-end justify-between gap-6">
          <div>
            <Eyebrow>{t("offerings.eyebrow")}</Eyebrow>
            <h2 className="font-display mt-6 text-3xl font-light tracking-tight sm:text-4xl lg:text-5xl">
              {t("offerings.h1")}
              <span className="italic" style={{ color: "var(--accent-gold)" }}>{t("offerings.h2")}</span>
            </h2>
          </div>
          <span
            data-testid="meditations-filter-all"
            className="rounded-full px-4 py-2 font-mono-alt text-[11px] uppercase tracking-[0.25em]"
            style={{ backgroundColor: "var(--pill-tag-bg)", color: "var(--pill-tag-text)" }}
          >
            {t("offerings.filterTag")}
          </span>
        </Reveal>

        <div className="grid gap-5 md:grid-cols-3">
          {META.map((m, i) => {
            const c = cards[i];
            return (
              <Reveal key={m.id} delay={i * 0.07} className={m.span}>
                <button
                  data-testid={`meditation-card-${m.id}`}
                  onClick={() => scrollToId("contact")}
                  className={`group flex h-full w-full flex-col justify-between rounded-3xl border p-8 text-left transition-all duration-300 hover:-translate-y-1 ${m.span}`}
                  style={{ borderColor: "var(--border-delicate)", backgroundColor: "var(--bg-canvas)" }}
                  onMouseEnter={(e) => (e.currentTarget.style.borderColor = "var(--border-hover)")}
                  onMouseLeave={(e) => (e.currentTarget.style.borderColor = "var(--border-delicate)")}
                >
                  <div>
                    <div className="flex items-start justify-between">
                      <span className="flex h-11 w-11 items-center justify-center rounded-full" style={{ backgroundColor: "var(--pill-tag-bg)", color: "var(--pill-tag-text)" }}>
                        <m.icon size={19} strokeWidth={1.75} />
                      </span>
                      <ArrowUpRight size={18} className="opacity-0 transition-opacity group-hover:opacity-100" style={{ color: "var(--accent-gold)" }} />
                    </div>
                    <h3 className="font-display mt-6 text-2xl font-normal leading-snug sm:text-3xl">{c.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--text-secondary)" }}>{c.desc}</p>
                  </div>
                  <p className="mt-8 font-mono-alt text-[11px] uppercase tracking-[0.25em]" style={{ color: "var(--text-muted)" }}>
                    {c.tag}
                  </p>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
